<template>
  <div
    class="text-md 2xl:text-lg prose max-w-none text-black"
    id="markdown"
    v-html="compiledMarkdown"
  ></div>
</template>

<script>
import marked from "marked";
export default {
  name: "MarkdownPreview",
  props: {
    text: String,
  },
  computed: {
    compiledMarkdown() {
      return marked(this.text);
    },
  },
};
</script>

<style>
#markdown a {
  color: #f7723e;
}

#markdown strong {
  font-weight: 900;
}

#markdown a:hover {
  text-decoration: underline;
}

#markdown img {
  margin: 0 auto;
}
</style>